"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Ribbon_1 = require("./Ribbon");
exports.default = Ribbon_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Ribbon/index.js
// module id = 1234
// module chunks = 8